import axios from "axios";
import { headersProvider } from "../apiHelpers";
import constants from "../constants";

export const createDocument = ({ agreementId }) =>
  axios.post(
    `${constants.apiHost}/docs/create`,
    {
      agreementId,
    },
    {
      headers: headersProvider(),
    },
  );

export const getLink = ({ agreementId }) =>
  axios.get(`${constants.apiHost}/docs/getLink/${agreementId}`, {
    headers: headersProvider(),
  });

export const shareLink = ({ agreementId }) =>
  axios.get(`${constants.apiHost}/docs/shareLink/${agreementId}`, {
    headers: headersProvider(),
  });

export const grantPermission = ({
  role,
  type,
  emailAddress,
  documentId,
  documetEditorId,
}) =>
  axios.post(
    `${constants.apiHost}/docs/permission/${documetEditorId}`,
    {
      role,
      type,
      emailAddress,
      documentId,
    },
    {
      headers: headersProvider(),
    },
  );
export const fetchDocsPermission = (documentEditorId) =>
  axios.get(`${constants.apiHost}/docs/fetchPermission/${documentEditorId}`, {
    headers: headersProvider(),
  });
export const fetchDocsfetchRevisions = (documentEditorId) =>
  axios.get(`${constants.apiHost}/docs/fetchRevisions/${documentEditorId}`, {
    headers: headersProvider(),
  });
export const fetchDocsContent = (documentEditorId) =>
  axios.get(`${constants.apiHost}/docs/fetchDocsContent/${documentEditorId}`, {
    headers: headersProvider(),
  });
export const deleteDocsPermission = (documentEditorId) =>
  axios.get(
    `${constants.apiHost}/docs/deleteDocsPermission/${documentEditorId}`,
    {
      headers: headersProvider(),
    },
  );
export const GET_DownloadDocsPdfLink = ({ agreementId }) =>
  axios.get(`${constants.apiHost}/docs/downloadDocsPdfLink/${agreementId}`, {
    headers: headersProvider(),
  });
export const fetchDocsContentBase64 = (agreementId) =>
  axios.get(`${constants.apiHost}/docs/fetchDocsContentBase64/${agreementId}`, {
    headers: headersProvider(),
  });
